import {
  Accordion,
  AccordionSummary,
  Divider,
  Grid,
  AccordionDetails,
  ImageList,
  ImageListItem,
} from '@mui/material';
import { EbayListing } from '../ebayModel';
import { EbayListingDetails } from '../ebayListingDetailModel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
  value: EbayListing | null;
  valueDetail: EbayListingDetails | null;
  country: string;
  sellerId: number;
}

export default function EbayListingDisplay({ value, valueDetail, country, sellerId }: Props) {
  let listing = value?.ebayItems.find((x) => x.sellerId === sellerId);
  let crossInit = value?.crossReferences?.map((x) => x.mpn);
  let crossRefs =
    crossInit && crossInit.length > 0
      ? crossInit.reduce((agg, cur, idx) => (idx === 0 ? cur : agg + ', ' + cur))
      : '';
  let warrantyDesc =
    '<h2>Standard AutoShack Warranty</h2>' +
    '<p><b>IMPORTANT: </b> By using your Autohack product, you are agreeing to be bound by the terms of the AutoShack Warranty as set out below. Do not use your product until you have read the terms of the warranty agreement. If you do not agree to the terms of the warranty agreement, do not use the product and return it within the return period stated in AutoShack’s return policy. </p>' +
    '<p>AutoShack hereby warrants, to the original purchaser, that all auto parts & amp; accessories contained in the original packaging against any defects in material and workmanship. All parts sold by AutoShack are brand new, serviceable, and functional. If an auto part is found to be defective within six months * from the original date of purchase AutoShack shall, at its discretion, provide either a one-time replacement part. <strong>Replacement parts are warrantied for 90 days from the date of exchange or the remainder of the warranty period on the original part, whichever is longer.</strong> AutoShack is not responsible for, and warranty does not cover, any damages arising from a failure to operate the product within its intended uses. This warranty does not cover products purchased from sources other than AutoShack. No reimbursements will be given for delay, labor, mileage, or any other costs involved in installation or re - installation of the auto parts in question. Warranty does not cover parts installed for an incorrect application. Warranty and shipping damage - related claims may require authentication including, but not limited to Mechanic Diagnosis, Pictures or Video of damaged goods  – do not dispose of parts until instructed. Failure to provide authenticating documentation could result in denial of current warranty claim and forfeit of future warranty. Please note that Struts and Complete Struts must be purchased in pairs(front or rear) or warranty is NULL & amp; VOID. </p>' +
    '<p>All warranty claims require a copy of your original purchase receipt, an image of the warrantied part not attached to the vehicle, and an image showing the part stamp, if visible, on the warrantied part. You may be required to return the part for inspection and you may be required to purchase a new replacement part while the warranty claim is being processed. Once the warranty claim has been reviewed and approved AutoShack will, at their discretion, provide you with a one-time replacement.</p>' +
    '<p>* Tonneau Covers, Fender Flares, Fuel Pumps, Wheel Spacers and Wheel Lugs are covered by a 90 - day warranty. Wiper Blades, Gaskets and Filters do not come with any Warranty.</p>';
  return (
    value && (
      <Accordion sx={{ border: 1 }}>
        <AccordionSummary
          sx={{ borderBottom: 3 }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Grid container>
            <Grid item xs={12}>
              <h4 style={{ padding: 0, margin: 0 }}>eBay {country}</h4>
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Placements
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Listing
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              # Fitments
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              # Mpn
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Quantity
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Images
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value.productPlacements.map((x) => x.placementName).toString()}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {listing?.listingId}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value?.fitments.length}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value?.crossReferences.length}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value.inStockQuantity}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value.images.length}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Title:
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Sub Title:
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'center' }}>
              {listing?.title}
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'center' }}>
              {listing?.subtitle}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#262626' }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Primary Category
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Secondary Category
            </Grid>
            <Grid item xs={6}>
              {listing?.primaryCategoryName}
            </Grid>
            <Grid item xs={6}>
              {listing?.secondaryCategoryName}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Primary Store Category
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Secondary Store Category
            </Grid>
            <Grid item xs={6}>
              {listing?.primaryStoreCategoryName}
            </Grid>
            <Grid item xs={6}>
              {listing?.secondaryStoreCategoryName}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Brand
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Product Display Name
            </Grid>
            <Grid item xs={6}>
              {value.brand}
            </Grid>
            <Grid item xs={6}>
              {listing?.webStoreDisplayName}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Description
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Additional Description
            </Grid>
            <Grid item xs={6}>
              <div
                style={{ maxHeight: 350, overflow: 'auto' }}
                dangerouslySetInnerHTML={{ __html: listing?.description ?? '' }}
              />
            </Grid>
            <Grid item xs={6}>
              <div
                style={{ maxHeight: 350, overflow: 'auto' }}
                dangerouslySetInnerHTML={{ __html: listing?.additionalDescription ?? '' }}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Attributes
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Dimensions
            </Grid>
            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  Type
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  Value
                </Grid>
                {valueDetail?.listingAttributes.map((x) => (
                  <>
                    <Grid item xs={6}>
                      {x.name}
                    </Grid>
                    <Grid item xs={6}>
                      {x.listingAttributeValues.map((y) => y.value).toString()}
                    </Grid>
                  </>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Length:
                </Grid>
                <Grid item xs={6}>
                  {value.length}"
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Width:
                </Grid>
                <Grid item xs={6}>
                  {value.width}"
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Height:
                </Grid>
                <Grid item xs={6}>
                  {value.height}"
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Weight:
                </Grid>
                <Grid item xs={6}>
                  {value.weight} lb(s)
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
                >
                  Profiles:
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Payment:
                </Grid>
                <Grid item xs={6}>
                  {listing?.paymentPolicyId}
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Return:
                </Grid>
                <Grid item xs={6}>
                  {listing?.returnPolicyId}
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Shipping:
                </Grid>
                <Grid item xs={6}>
                  {listing?.shippingPolicyId}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Interchange PartNumber
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Warranty Description
            </Grid>
            <Grid item xs={6}>
              {crossRefs}
            </Grid>
            <Grid item xs={6}>
              <div
                style={{ maxHeight: 350, overflow: 'auto' }}
                dangerouslySetInnerHTML={{ __html: warrantyDesc }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <ImageList sx={{ width: 900, height: 250 }} cols={5} rowHeight={164}>
                {value.images.map((x) => (
                  <ImageListItem key={x.imageUrl}>
                    <img
                      srcSet={`${x.imageUrl}?w=164&h=164`}
                      src={`${x.imageUrl}?w=164&h=164`}
                      alt=""
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    )
  );
}
